import React from "react";
import Spinner from "@ui-components/Spinner";
import {BlurredPlaceholderProps} from "./types";

export function BlurredPlaceholder({loading, children}: BlurredPlaceholderProps) {
  return (
    <div className="w-full h-full relative">
      {loading && (
        <div className="absolute inset-0 bg-white opacity-60 transition-opacit z-10">
          <Spinner classes="relative" styleType="white"/>
        </div>
      )}
      {children}
    </div>
  )
}